import { useModal } from '@workspace/design-system/components/dialog/modal-provider';
import type { ReactNode } from 'react';

export function useDialog() {
  const { modals, setModal } = useModal();

  const openDialog = (dialog: ReactNode) => {
    setModal((prev) => [...prev, dialog]);
  };
  const closeDialog = () => {
    setModal((prev) => prev.slice(0, -1));
  };
  return {
    openDialog,
    closeDialog,
  };
}
